import img_Marque from '../images/marque.png';

const Marque = () => (
  <div className="marque">
    <img src={img_Marque} />
  </div>
)

export default Marque



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Marque.js